<div class="main">
  <app-toolbar></app-toolbar>
  <router-outlet></router-outlet>
  <div class="spacer"></div>
  <app-footer></app-footer>
</div>